module.exports = __webpack_public_path__ + "img/20300____-38.prt.b85fb573.jpg";